import { render, staticRenderFns } from "./PrkAssessmentMethodsSelect.vue?vue&type=template&id=01620fec&scoped=true&"
import script from "./PrkAssessmentMethodsSelect.vue?vue&type=script&lang=js&"
export * from "./PrkAssessmentMethodsSelect.vue?vue&type=script&lang=js&"
import style0 from "./PrkAssessmentMethodsSelect.vue?vue&type=style&index=0&id=01620fec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01620fec",
  null
  
)

export default component.exports